export default __webpack_public_path__ + "static/media/4.16fca31c.png";